import { TYPE_RGB, TYPE_RGBA, TYPE_CMYK } from './types.js';

const sizeMap = {
    [TYPE_RGB]: 3,
    [TYPE_RGBA]: 4,
    [TYPE_CMYK]: 4
};

/**
 * 获取一像素的数据长度
 * @param { number } mode 
 * @returns { number }
 */
export function getPixelSize(mode) {
    return sizeMap[mode] || 1;
}